import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Divider, Form, Input, Label, Segment } from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import PropTypes from "prop-types";

class DuplicateProductForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            product: props.product
        };
    }

    handleSubmit() {
        let request = {
            code: this.state.product.code,
            code2: this.state.product.code2,
            code3: this.state.product.code3,
            cost: this.state.product.cost,
            priceWithVat: this.state.product.priceWithVat,
            price_lists: this.state.product.price_lists.map((priceList) => ({
                pricelistID: priceList.pricelistID,
                price: priceList.pivot.price
            })),
            name: this.state.product.name,
            manufacturerName: this.state.product.manufacturerName,
            supplier_id: this.state.product.supplier_id,
            vatrate_id: this.state.product.vatrate_id,
            group_id: this.state.product.group_id,
            brand_id: this.state.product.brand_id,
            unitID: this.state.product.unitID,
            volume: this.state.product.volume,
            country_id: this.state.product.country_id,
            description: this.state.product.description,
            product_attributes: this.state.product.product_attributes.map((attribute) => ({
                name: attribute.name,
                value: attribute.value
            })),
            variations: this.state.product.variations.map((variation) => (variation.id))

        };

        if (this.state.product.parent_product) {
            request["parentProductID"] = this.state.product.parent_product.productID;
        }

        if (this.state.createMatrix) {
            request["createMatrix"] = {
                code: this.state.product.matrixCode,
                dimension_id_1: 5,
                dimension_id_2: 6,
                dimension_id_3: 7,
                old_product_variation_id_1: this.state.product.oldProductVariations[0].id,
                old_product_variation_id_2: this.state.product.oldProductVariations[1].id,
                old_product_variation_id_3: this.state.product.oldProductVariations[2].id,
            };
        }

        this.props.onSubmit(request);

    }

    render() {
        return (
            <Form onSubmit={() => {
                this.handleSubmit();
            }}>
                <Form.Input
                    label='Code'
                    value={this.state.product.code}
                    onChange={(e) => {
                        this.setState({
                            product: {
                                ...this.state.product,
                                code: e.target.value
                            }
                        });
                    }}
                />
                <Form.Input
                    label={"EAN" + (this.state.product.parent_product ? " (Matrix-EAN: " + this.state.product.parent_product.code2 + ")" : "")}
                    value={this.state.product.code2}
                    onChange={(e) => {
                        this.setState({
                            product: {
                                ...this.state.product,
                                code2: e.target.value
                            }
                        });
                    }}
                />
                <Form.Input
                    label={"Code3"}
                    value={this.state.product.code3}
                    onChange={(e) => {
                        this.setState({
                            product: {
                                ...this.state.product,
                                code3: e.target.value
                            }
                        });
                    }}
                />

                <Form.Input
                    label='Name'
                    value={this.state.product.name}
                    onChange={(e) => {
                        this.setState({
                            product: {
                                ...this.state.product,
                                name: e.target.value
                            }
                        });
                    }}
                />

                <Form.Input label='description'
                            value={this.state.product.description}
                            onChange={(e) => {
                                this.setState({
                                    product: {
                                        ...this.state.product,
                                        description: e.target.value
                                    }
                                });
                            }}
                />


                <Form.Input label='manufacturerName'
                            value={this.state.product.manufacturerName}
                            onChange={(e) => {
                                this.setState({
                                    product: {
                                        ...this.state.product,
                                        manufacturerName: e.target.value
                                    }
                                });
                            }}
                />

                {/*Product Group */}

                <Form.Dropdown
                    value={this.state.product.group_id}
                    fluid
                    label={"Product Group"}
                    selection
                    options={this.props.productGroups
                        .map((group) => ({
                            key: group.id,
                            text: group.name,
                            value: group.id
                        }))}
                    onChange={(e, { value }) => {
                        this.setState(({ product }) => ({
                            product: {
                                ...product,
                                group_id: value
                            }
                        }));
                    }}
                />

                {/* Supplier */}

                <Form.Dropdown
                    value={this.state.product.supplier_id}
                    fluid
                    label={"Supplier"}
                    selection
                    search
                    options={this.props.suppliers
                        .map((supplier) => ({
                            key: supplier.id,
                            text: supplier.name + " (" + supplier.supplier_id + ")",
                            value: supplier.id
                        }))}
                    onChange={(e, { value }) => {
                        this.setState(({ product }) => ({
                            product: {
                                ...product,
                                supplier_id: value
                            }
                        }));
                    }}
                />

                <Form.Dropdown
                    value={this.state.product.country_id}
                    fluid
                    label={"Country"}
                    selection
                    search
                    options={this.props.countries
                        .map((country) => ({
                            key: country.id,
                            text: country.name + " (" + country.country_id + ")",
                            value: country.id
                        }))}
                    onChange={(e, { value }) => {
                        this.setState(({ product }) => ({
                            product: {
                                ...product,
                                country_id: value
                            }
                        }));
                    }}
                />


                <Form.Dropdown
                    value={this.state.product.brand_id}
                    fluid
                    label={"Brand"}
                    selection
                    search
                    options={this.props.brands
                        .map((brand) => ({
                            key: brand.id,
                            text: brand.name + " (" + brand.brandID + ")",
                            value: brand.id
                        }))}
                    onChange={(e, { value }) => {
                        this.setState(({ product }) => ({
                            product: {
                                ...product,
                                brand_id: value
                            }
                        }));
                    }}
                />


                {/* Prices */}

                <Form.Input type='number' step='0.01' min='0' label='cost'
                            value={this.state.product.cost}
                            onChange={(e) => {
                                this.setState({
                                    product: {
                                        ...this.state.product,
                                        cost: e.target.value
                                    }
                                });
                            }}
                />

                <Form.Input label='priceWithVat'
                            value={this.state.product.priceWithVat}
                            onChange={(e) => {
                                this.setState({
                                    product: {
                                        ...this.state.product,
                                        priceWithVat: e.target.value
                                    }
                                });
                            }}
                />

                {/* Price Lists */}

                {
                    this.state.product.price_lists &&
                    <div>
                        {this.state.product.price_lists.map((list, key) =>
                            <Form.Input key={key}
                                        type='number' step='0.01' min='0'
                                        label={list.name}
                                        value={this.state.product.price_lists[key].pivot.price}
                                        onChange={(e) => {
                                            this.setState({
                                                product: {
                                                    ...this.state.product,
                                                    price_lists: this.state.product.price_lists.map((list, mapKey) => {
                                                        if (key === mapKey) {
                                                            list.pivot.price = e.target.value;
                                                            return list;
                                                        }
                                                        return list;
                                                    })
                                                }
                                            });
                                        }}
                            />
                        )}
                    </div>
                }
                {
                    !this.state.product.product_attributes &&
                    <div>
                        <Divider horizontal>Attributes</Divider>
                        <br/>
                        <Button
                            fluid
                            type={"button"}
                            primary
                            onClick={(e) => {
                                e.preventDefault();
                                let product_attributes = this.state.product.product_attributes || [];
                                product_attributes.unshift({
                                    name: "newAttribute",
                                    value: ""
                                });
                                this.setState(({ product }) => ({
                                    product: {
                                        ...product,
                                        product_attributes
                                    }
                                }));
                            }}>Add new Attribute</Button>
                    </div>
                }
                {
                    this.state.product.product_attributes &&
                    <div>

                        <Divider horizontal>Attributes</Divider>
                        <br/>
                        <Button
                            fluid
                            primary
                            icon={"plus"}
                            type={"button"}
                            onClick={(e) => {
                                e.preventDefault();
                                let product_attributes = this.state.product.product_attributes || [];
                                product_attributes.unshift({
                                    name: "newAttribute",
                                    value: ""
                                });
                                this.setState(({ product }) => ({
                                    product: {
                                        ...product,
                                        product_attributes
                                    }
                                }));
                            }}>Add new Attribute</Button>
                        {this.state.product.product_attributes.map((attribute, key) =>
                            <div key={key}>

                                <Form.Input
                                    value={attribute.value}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        this.setState(({ product }) => ({
                                            product: {
                                                ...product,
                                                product_attributes: product.product_attributes.map((attribute, mapKey) => {
                                                    if (key === mapKey) {
                                                        return {
                                                            name: attribute.name,
                                                            value
                                                        };
                                                    }
                                                    return attribute;
                                                })
                                            }
                                        }));
                                    }}
                                >
                                    <Label><Input
                                        value={attribute.name}
                                        onChange={(e) => {
                                            const name = e.target.value;
                                            this.setState(({ product }) => ({
                                                product: {
                                                    ...product,
                                                    product_attributes: product.product_attributes.map((attribute, mapKey) => {
                                                        if (key === mapKey) {
                                                            return {
                                                                name,
                                                                value: attribute.value
                                                            };
                                                        }
                                                        return attribute;
                                                    })
                                                }
                                            }));
                                        }}
                                    /></Label>
                                    <input/>
                                    <Button onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({
                                            product: {
                                                ...this.state.product,
                                                product_attributes: this.state.product.product_attributes.filter((attribute2) => attribute2.name !== attribute.name)
                                            }
                                        });
                                    }}>Remove</Button>
                                </Form.Input>
                            </div>
                        )}
                    </div>
                }
                {
                    this.state.product.variations && !this.state.createMatrix &&
                    <div>
                        <Divider horizontal>Dimensions</Divider>
                        {
                            this.state.product.variations.map((variation, key) => {
                                    return (
                                        <Form.Dropdown
                                            value={variation.id}
                                            key={key}
                                            fluid
                                            search
                                            label={this.props.dimensions[variation.dimension_id].name}
                                            selection
                                            options={this.props.dimensions[variation.dimension_id].variations.sort((a, b) => a.order > b.order ? 1 : -1)
                                                .map((dimVariation) => ({
                                                    key: dimVariation.id,
                                                    text: dimVariation.name,
                                                    value: dimVariation.id
                                                }))}
                                            onChange={(e, { value }) => {
                                                let variations = this.state.product.variations;
                                                variations[key] = {
                                                    dimension_id: variation.dimension_id,
                                                    id: value
                                                };
                                                this.setState(({ product }) => ({
                                                    product: {
                                                        ...product,
                                                        variations
                                                    }
                                                }));
                                            }}

                                        />
                                    );
                                }
                            )
                        }
                    </div>
                }
                {
                    !this.state.product.parent_product &&
                    <div>
                        <Divider horizontal>Create New Matrix Product</Divider>

                        {!this.state.createMatrix ?
                            <Button onClick={(e) => {
                                e.preventDefault();
                                this.setState(({ product }) => ({
                                    createMatrix: true,
                                    product: {
                                        ...product,
                                        matrixCode: "",
                                        variations: [
                                            {
                                                dimension_id: 5,
                                                id: 1
                                            },
                                            {
                                                dimension_id: 6,
                                                id: 1
                                            },
                                            {
                                                dimension_id: 7,
                                                id: 1
                                            }
                                        ],
                                        oldProductVariations: [
                                            {
                                                dimension_id: 5,
                                                id: 1
                                            },
                                            {
                                                dimension_id: 6,
                                                id: 1
                                            },
                                            {
                                                dimension_id: 7,
                                                id: 1
                                            }
                                        ],
                                    }

                                }));
                            }}>Create new Matrix</Button>
                            :
                            <Button onClick={(e) => {
                                e.preventDefault();
                                this.setState({ createMatrix: false });
                            }}>Dismiss creating new Matrix</Button>
                        }
                        {
                            this.state.createMatrix &&
                            <div>
                                <Divider horizontal>New Matrix Code</Divider>

                                <Segment>
                                    <Form.Input label='new matrix code'
                                                value={this.state.product.matrixCode}
                                                onChange={(e) => {
                                                    this.setState({
                                                        product: {
                                                            ...this.state.product,
                                                            matrixCode: e.target.value
                                                        }
                                                    });
                                                }}
                                    />
                                </Segment>

                                <Divider horizontal>New Product Dimensions</Divider>

                                <Segment>
                                    {
                                        this.state.product.variations.map((variation, key) => {
                                            return (
                                                <Form.Dropdown
                                                    value={variation.id}
                                                    key={variation.dimension_id}
                                                    fluid
                                                    search
                                                    label={this.props.dimensions[variation.dimension_id].name}
                                                    selection
                                                    options={this.props.dimensions[variation.dimension_id].variations.sort((a, b) => a.order > b.order ? 1 : -1)
                                                        .map((dimVariation) => ({
                                                            key: dimVariation.id,
                                                            text: dimVariation.name,
                                                            value: dimVariation.id
                                                        }))}
                                                    onChange={(e, { value }) => {
                                                        let variations = this.state.product.variations;
                                                        variations[key] = {
                                                            dimension_id: variation.dimension_id,
                                                            id: value
                                                        };
                                                        this.setState(({ product }) => ({
                                                            product: {
                                                                ...product,
                                                                variations
                                                            }
                                                        }));
                                                    }}

                                                />
                                            );
                                        })
                                    }
                                </Segment>

                                <Divider horizontal>Old Product Dimensions</Divider>

                                <Segment>
                                    {
                                        this.state.product.oldProductVariations.map((variation, key) => {
                                            return (
                                                <Form.Dropdown
                                                    value={variation.id}
                                                    key={variation.dimension_id}
                                                    fluid
                                                    search
                                                    label={this.props.dimensions[variation.dimension_id].name}
                                                    selection
                                                    options={this.props.dimensions[variation.dimension_id].variations.sort((a, b) => a.order > b.order ? 1 : -1)
                                                        .map((dimVariation) => ({
                                                            key: dimVariation.id,
                                                            text: dimVariation.name,
                                                            value: dimVariation.id
                                                        }))}
                                                    onChange={(e, { value }) => {
                                                        let oldProductVariations = this.state.product.oldProductVariations;
                                                        oldProductVariations[key] = {
                                                            dimension_id: variation.dimension_id,
                                                            id: value
                                                        };
                                                        this.setState(({ product }) => ({
                                                            product: {
                                                                ...product,
                                                                oldProductVariations
                                                            }
                                                        }));
                                                    }}

                                                />
                                            );
                                        })
                                    }
                                </Segment>
                            </div>
                        }
                    </div>
                }
                <Button type='submit'>Save</Button>
            </Form>
        );
    }
}

DuplicateProductForm.propTypes = {
    product: PropTypes.object.isRequired,
    dimensions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    translate: getTranslate(state.localize)
});


const mapDispatchToProps = (dispatch) => {
    return ({});
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DuplicateProductForm);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/ManageProducts/components/DuplicateProductForm/index.js